import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../helpers/reselectHelpers';
import {
  getIsSettingsLocalApplicationAsyncStatus,
  getIsSettingsLocalApplicationLoading,
} from '../../store/panels/settings/settingsPanelSelectors';
import {SettingsDevelopers} from './settingsDevelopers';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  isApplicationLoading: getIsSettingsLocalApplicationLoading,
  localApplicationAsyncStatus: getIsSettingsLocalApplicationAsyncStatus,
}));

export const SettingsDevelopersContainer = connect(mapStateToProps)(SettingsDevelopers);
